import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { MatTableDataSource, MatSort } from '@angular/material';
import { SearchCompleteFilterComponent } from '../../controls/search-complete-filter/search-complete-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { Router } from '@angular/router';
import { MenuService } from 'src/app/services/menu.service';
import { CallerSearchItem } from '../../../model/caller-search-item';

@Component({
  selector: 'app-caller-search',
  templateUrl: './caller-search.component.html',
  styleUrls: ['./caller-search.component.css']
})
export class CallerSearchComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  displayedColumns: string[] = ['id', 'name', 'star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchCompleteFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(
    private router: Router
    , private menuService: MenuService) {
    this.menuService.setMenuTitle('Llamador', 'admisión llamador');
  }

  ngOnInit(): void {

  }

  startCaller(callerSearchItem: CallerSearchItem): void {
      this.router.navigate(['patient-caller', callerSearchItem.Id]);
  }

  onStartSearch(): void {
    this.loading = true;
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<CallerSearchItem>): void {
    this.searchFilters = response.searchFilters;
    this.pager.setItems(response.items);
  }
}
